// extracted by mini-css-extract-plugin
export var wrapper = "PagePress-module--wrapper--0aPXR";